(ns motorsaif.web.components.user-handle
  (:require
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.log :as log]
   [re-frame.core :as rf]
   [goog.functions :refer [debounce]]
   [reagent.core :as r]
   [taoensso.encore :as encore]))

(def ^:private *limited-fn (atom nil))

(def ^:private limiter
  (encore/rate-limiter
   {:one-per-sec [1 (encore/ms :secs 1)]}))

(defn username-request
  [username on-ret]
  (let [req {:type :POST
             :url "/api/account/username-check"
             :id :username-req
             :params {:handle username}
             :handler (fn [{:keys [success]}]
                        (on-ret success))
             :error-handler #(log/info [:error %])}
        [_ backoff] (limiter :req)
        call-fn #(when @*limited-fn
                   (@*limited-fn)
                   (reset! *limited-fn nil))]

    (reset! *limited-fn #(rf/dispatch [:do-ajax req]))
    (if backoff
      (js/setTimeout #(call-fn) backoff)
      (call-fn))))

(defn- -username-change-fn [{:keys [val *state set-val]}]
  (cond (< (count val) 3) (reset! *state nil)
        (re-find #"\s" val) (reset! *state :spaces)
        :else
        (username-request val (fn [success]
                                (set-val [:user :user/handle-valid] success)
                                (reset! *state (if success :valid :invalid))))))

(def username-change-fn (debounce -username-change-fn 200))

(defn username-input [{:keys [path form label helper]}]
  (let [*state (r/atom nil)
        {:keys [input set-val]} form]
    (fn []
      [:div
       [(fn []
          [:span#username-availability
           {:class (when (= @*state :valid) "valid")}
           (condp = @*state
             nil nil
             :valid (tr :forms.sign-up.username.available)
             :spaces "Don't use spaces"
             :invalid (tr :forms.sign-up.username.taken))])]
       [input
        (cond->
            {:on-change
             #(username-change-fn {:val %
                                   :set-val set-val
                                   :*state *state})
             :no-spaces true
             :helper helper
             :placeholder (tr :forms.sign-up.username.placeholder)}
          label (assoc :label label)
          helper (assoc :helper helper)) path]])))
